(function () {
  function initYmmRoot(root) {
    if (root.dataset.ymmInitialized === 'true') return;
    root.dataset.ymmInitialized = 'true';

    let selectedMake = null;
    let selectedYear = null;

    const makeSelect = root.querySelector('[data-ymm-field="make"]');
    const yearSelect = root.querySelector('[data-ymm-field="year"]');
    const engineSelect = root.querySelector('[data-ymm-field="engine"]');
    const bodyStyleSelect = root.querySelector('[data-ymm-field="body-style"]');
    const findProductForm = root.querySelector('[data-ymm-form]');

    if (!makeSelect || !yearSelect || !engineSelect || !bodyStyleSelect || !findProductForm) return;

    const redirectOnSubmit = root.dataset.ymmRedirect !== 'false';

    makeSelect.addEventListener('change', (event) => {
      selectedMake = event.target.value;
      selectedYear = null;
      filterOptionsByMake(selectedMake);
      resetInputs('make');
    });

    yearSelect.addEventListener('change', (event) => {
      selectedYear = event.target.value;
      engineSelect.selectedIndex = 0;
      engineSelect.disabled = true;
      bodyStyleSelect.selectedIndex = 0;
      bodyStyleSelect.disabled = true;
      filterEngineOptions(selectedMake, selectedYear);
      resetInputs('year');
    });

    engineSelect.addEventListener('change', () => {
      bodyStyleSelect.selectedIndex = 0;
      bodyStyleSelect.disabled = true;
      resetInputs('engine');
    });

    function filterOptionsByMake(make) {
      if (!make) {
        yearSelect.querySelectorAll('option').forEach((option) => {
          option.style.display = '';
        });
        engineSelect.querySelectorAll('option').forEach((option) => {
          option.style.display = '';
        });
        return;
      }

      yearSelect.querySelectorAll('option').forEach((option) => {
        if (option.value === '') return;
        const makeCompatible = option.getAttribute('data-make-compatible');
        if (makeCompatible) {
          const compatibleMakes = makeCompatible.split(',').map((value) => value.trim());
          option.style.display = compatibleMakes.includes(make) ? '' : 'none';
        } else {
          option.style.display = 'none';
        }
      });

      filterEngineOptions(make, selectedYear);
    }

    function filterEngineOptions(make, year) {
      if (!make) {
        engineSelect.querySelectorAll('option').forEach((option) => {
          option.style.display = '';
        });
        return;
      }

      engineSelect.querySelectorAll('option').forEach((option) => {
        if (option.value === '') return;

        const makeCompatible = option.getAttribute('data-make-compatible');
        const yearCompatible = option.getAttribute('data-year-compatible');

        let isMakeCompatible = false;
        if (makeCompatible) {
          const compatibleMakes = makeCompatible.split(',').map((value) => value.trim());
          isMakeCompatible = compatibleMakes.includes(make);
        }

        let isYearCompatible = true;
        if (year && yearCompatible) {
          const compatibleYears = yearCompatible.split(',').map((value) => value.trim());
          isYearCompatible = compatibleYears.includes(year);
        } else if (year && !yearCompatible) {
          isYearCompatible = false;
        }

        if (isMakeCompatible && isYearCompatible) {
          option.style.display = '';
          option.disabled = false;
        } else {
          option.style.display = 'none';
          option.disabled = true;
        }
      });
    }

    function resetInputs(adjusted) {
      if (adjusted === 'make') {
        yearSelect.selectedIndex = 0;
        yearSelect.disabled = false;
        engineSelect.disabled = true;
        engineSelect.selectedIndex = 0;
        bodyStyleSelect.disabled = true;
        bodyStyleSelect.selectedIndex = 0;
      }

      if (adjusted === 'year') {
        engineSelect.disabled = false;
        engineSelect.selectedIndex = 0;
        bodyStyleSelect.disabled = true;
        bodyStyleSelect.selectedIndex = 0;
      }

      if (adjusted === 'engine') {
        bodyStyleSelect.disabled = false;
        bodyStyleSelect.selectedIndex = 0;
      }
    }

    function findEngineOption(make, year, engine) {
      for (const option of engineSelect.querySelectorAll('option')) {
        if (!option.value || option.value !== engine) continue;

        const makeCompatible = option.getAttribute('data-make-compatible');
        const yearCompatible = option.getAttribute('data-year-compatible');

        if (!makeCompatible) continue;

        const compatibleMakes = makeCompatible.split(',').map((value) => value.trim());
        if (!compatibleMakes.includes(make)) continue;

        if (year && yearCompatible) {
          const compatibleYears = yearCompatible.split(',').map((value) => value.trim());
          if (!compatibleYears.includes(year)) continue;
        }

        return option;
      }

      return null;
    }

    function clearForm() {
      selectedMake = null;
      selectedYear = null;
      makeSelect.selectedIndex = 0;
      yearSelect.selectedIndex = 0;
      yearSelect.disabled = true;
      engineSelect.selectedIndex = 0;
      engineSelect.disabled = true;
      bodyStyleSelect.selectedIndex = 0;
      bodyStyleSelect.disabled = true;
      filterOptionsByMake(null);
    }

    function isFormMatchingVehicle(vehicle) {
      if (!vehicle?.make) {
        return !makeSelect.value && !yearSelect.value && !engineSelect.value;
      }

      const engineOption = findEngineOption(vehicle.make, vehicle.year, vehicle.engine);
      return (
        makeSelect.value === vehicle.make &&
        yearSelect.value === vehicle.year &&
        engineOption?.selected === true &&
        bodyStyleSelect.value === (vehicle.body || 'all')
      );
    }

    function restoreSavedVehicle() {
      const vehicle = window.TdVehicleStorage?.getSelectedVehicle();

      if (!vehicle?.make) {
        if (!isFormMatchingVehicle(null)) clearForm();
        return;
      }

      if (isFormMatchingVehicle(vehicle)) return;

      const yearOption = yearSelect.querySelector(`option[value="${CSS.escape(vehicle.year)}"]`);
      const engineOption = findEngineOption(vehicle.make, vehicle.year, vehicle.engine);
      const bodyOption = bodyStyleSelect.querySelector(
        `option[value="${CSS.escape(vehicle.body || 'all')}"]`
      );

      if (!yearOption || !engineOption || !bodyOption) return;

      makeSelect.value = vehicle.make;
      selectedMake = vehicle.make;
      filterOptionsByMake(selectedMake);
      yearSelect.disabled = false;

      yearSelect.value = vehicle.year;
      selectedYear = vehicle.year;
      filterEngineOptions(selectedMake, selectedYear);
      engineSelect.disabled = false;

      engineSelect.querySelectorAll('option').forEach((option) => {
        option.selected = option === engineOption;
      });
      bodyStyleSelect.disabled = false;
      bodyStyleSelect.value = vehicle.body || 'all';
    }

    restoreSavedVehicle();

    window.addEventListener('td:vehicle-storage-change', restoreSavedVehicle);
    window.addEventListener('storage', (event) => {
      if (event.key === window.TdVehicleStorage?.STORAGE_KEY) {
        restoreSavedVehicle();
      }
    });

    const RESULTS_URL = '/pages/year-make-product-search-results';
    let submitting = false;

    function runVehicleSearch(event) {
      event.preventDefault();
      if (submitting) return;

      const formData = {
        make: makeSelect.value,
        year: yearSelect.value,
        engine: engineSelect.value,
        bodyStyle: bodyStyleSelect.value,
      };

      let errors = 0;
      [makeSelect, yearSelect, engineSelect, bodyStyleSelect].forEach((select, index) => {
        const key = ['make', 'year', 'engine', 'bodyStyle'][index];
        if (!formData[key]) {
          select.style.border = '1px solid red';
          errors += 1;
        } else {
          select.style.border = '1px solid #ddd';
        }
      });

      if (errors !== 0) return;

      submitting = true;

      const vehicleData = {
        make: formData.make,
        year: formData.year,
        engine: formData.engine,
        body: formData.bodyStyle,
      };

      try {
        window.TdVehicleStorage?.addVehicle(vehicleData);
      } catch (error) {
        console.error(error);
      }

      // Pages that react to the vehicle in place (bundle builder) keep the shopper there.
      const handledInline = Boolean(document.querySelector('[data-td-vehicle-inline]'));

      if (redirectOnSubmit) {
        window.TdVehiclePopup?.close();
      }

      if (redirectOnSubmit && !handledInline) {
        // The vehicle rides along in the URL so results still work when storage is blocked.
        const resultsUrl = window.TdVehicleStorage?.getResultsUrl(vehicleData) || RESULTS_URL;
        if (window.location.pathname + window.location.search === resultsUrl) {
          window.location.reload();
          return;
        }
        window.location.assign(resultsUrl);
        return;
      }

      submitting = false;
      window.dispatchEvent(
        new CustomEvent('td:vehicle-set', {
          detail: vehicleData,
        })
      );
    }

    // Button clicks and Enter both fire submit, so one listener covers every path.
    findProductForm.addEventListener('submit', runVehicleSearch);
  }

  function initAllYmmRoots() {
    document.querySelectorAll('[data-td-ymm-root]').forEach(initYmmRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllYmmRoots);
  } else {
    initAllYmmRoots();
  }

  window.TdYmmSelection = {
    initAll: initAllYmmRoots,
  };
})();
